import { useAuthenticatedFetch } from './apiService';

export interface EmployeeType {
  id: string;
  manager_level: number;
  employee_email: string;
  [key: string]: any;
}

export const useEmployeeService = () => {
  const authenticatedFetch = useAuthenticatedFetch();

  return {
    fetchManagers: async (): Promise<EmployeeType[]> => {
      const res = await authenticatedFetch('/employees/');
      if (!res.ok) throw new Error('Failed to find top level managers');
      return await res.json();
    },
    searchEmployees: async (query: string): Promise<EmployeeType[]> => {
      const res = await authenticatedFetch(`/employees/search?query=${encodeURIComponent(query)}`);
      if (!res.ok) throw new Error('Failed to search employees');
      return await res.json();
    },
    fetchReports: async (managerEmail: string): Promise<EmployeeType[]> => {
      const res = await authenticatedFetch(`/employees/reports?manager_email=${encodeURIComponent(managerEmail)}`);
      if (!res.ok) throw new Error('Failed to fetch reports');
      return await res.json();
    },
    fetchSubordinateManagers: async (priorManagerEmail: string, priorManagerLevel: number): Promise<EmployeeType[]> => {
      const res = await authenticatedFetch(
        `/employees/subordinate_managers?prior_manager_email=${encodeURIComponent(priorManagerEmail)}&prior_manager_level=${priorManagerLevel}`
      );
      if (!res.ok) throw new Error('Failed to fetch subordinate managers');
      return await res.json();
    },
    fetchAllReports: async (managerEmail: string): Promise<EmployeeType[]> => {
      const res = await authenticatedFetch(`/employees/all_reports?manager_email=${encodeURIComponent(managerEmail)}`);
      if (!res.ok) throw new Error('Failed to fetch all reports');
      return await res.json();
    },
  };
};